import React, { useEffect, useState } from 'react';
import { Steps, Button, Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import ContentCustom from '../../components/ContentCustom/ContentCustom';
import { userRoles } from '../../utils/constants/tagColors';

const { Step } = Steps;

const Messages = ({ ticket }) => {
  const { t } = useTranslation();
  const [messages, setMessages] = useState([]);
  const [switchType, setSwitchType] = useState('MESSAGE');

  const admins = ['ADMIN', 'SUPER-ADMIN'];

  useEffect(() => {
    if (ticket) {
      setMessages(ticket.ticket_messages ?? []);
    }
  }, [ticket]);

  const filteredMessages = messages
    .filter((f) => f.type === switchType)
    .filter((g) => g.authorization !== 'BO')
    .sort((a, b) => new Date(b.date) - new Date(a.date));

  const items = filteredMessages.map((item) => {
    const role = item.author?.role?.split(':')[1] ?? 'UNKNOWN';
    return {
      key: item._id,
      content: (
        <>
          <span>
            {`Fait le ${format(new Date(item.date), 'dd/MM/yyyy HH:mm')} par `}
            <Tag color={userRoles[role]}>{t(`users.tags.${role}`)}</Tag>
          </span>
          <div>
            <strong>
              {admins.includes(role)
                ? "L'équipe Assurmax"
                : `${item.author?.first_name ?? ''} ${item.author?.last_name ?? ''}`}
            </strong>
            {` : ${item.value}`}
          </div>
          {item.comment && (
            <div>
              <strong>{t('settings.tickets.modal.show_comment')}</strong>
              {` : ${item.comment}`}
            </div>
          )}
        </>
      )
    };
  });

  return (
    <ContentCustom>
      <div style={{ marginBottom: 30 }}>
        <Button
          type={switchType === 'MESSAGE' ? 'primary' : ''}
          style={{ marginRight: 15 }}
          onClick={() => setSwitchType('MESSAGE')}
        >
          {t('buttons.show_messages')}
        </Button>
        <Button
          type={switchType === 'EDIT_VALUE' ? 'primary' : ''}
          onClick={() => setSwitchType('EDIT_VALUE')}
        >
          {t('buttons.show_modifications')}
        </Button>
      </div>

      {ticket && (
        <Steps
          type="dot"
          current={filteredMessages.length}
          orientation="vertical"
          items={items}
        />
      )}
    </ContentCustom>
  );
};

Messages.propTypes = {
  ticket: PropTypes.shape({
    value: PropTypes.string,
    _id: PropTypes.string,
    ticket_messages: PropTypes.arrayOf(
      PropTypes.shape({
        author: PropTypes.shape({
          role: PropTypes.string,
          first_name: PropTypes.string,
          last_name: PropTypes.string
        })
      })
    ).isRequired
  }).isRequired
};

export default Messages;
